import RelaxModel from "Base/model/RelaxModel";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import ParseRelax from "./ParseRelax";
import EntryPoint from "Engine/EntryPoint";
import ErrorsManager from "Base/ErrorsManager";

export default class Relax {
    constructor() {
        this.lastRequest = '';

        //this.init();
        this.addListeners();
    }

    init() {
        this.XHR = new XMLHttpRequest();
        this.XHR.addEventListener('error', this.onError.bind(this));
        this.XHR.addEventListener('load', this.onHasData.bind(this));

        this.restoreStateXHR = new XMLHttpRequest();
        this.restoreStateXHR.addEventListener('error', this.onError.bind(this));
        this.restoreStateXHR.addEventListener('load', this.onRestoreStateHasData.bind(this));

        this.realityCheckXHR = new XMLHttpRequest();
        this.realityCheckXHR.addEventListener('error', this.onError.bind(this));
        this.realityCheckXHR.addEventListener('load', this.onRealityCheckHasData.bind(this));

        this.getBalanceXHR = new XMLHttpRequest();
        this.getBalanceXHR.addEventListener('error', this.onError.bind(this));
        this.getBalanceXHR.addEventListener('load', this.onGetBalanceHasData.bind(this));

        this.pingXHR = new XMLHttpRequest();
        this.pingXHR.addEventListener('error', this.onError.bind(this));
        this.pingXHR.addEventListener('load', this.onPingHasData.bind(this));


    }

    addListeners() {
        GlobalDispatcher.add('model:getServerData', this.onModelGetServerData, this);
    }

    onModelGetServerData() {
        //this.sendSetRestoreState();
    }

    action(data) {
        switch (data.action) {
            case 'init':
                this.sendInit(data);
                break;
            case 'spin':
                this.sendSpin(data);
                break;
            case 'resetrealitycheck':
                this.sendResetRealityCheck(data);
                break;
            case 'gamefinished':
                this.sendGameFinished(data);
                break;
            case 'getBalance':
                this.sendGetBalance(data);
                break;
            case 'ping':
                this.sendPing(data);
                break;
        }
    }

    sendInit() {
        switch (RelaxModel.moneyMode) {
            case 'real':
                this.sendGetToken();
                break;
            case 'fun':
                this.sendFunMoneyLogin();
                break;
            case 'demo':
                this.sendDemoLogin();
                break;
        }
    }

    sendGetToken(data) {
        this.lastRequest = 'gettoken';
        let requestData = {
            ticket: RelaxModel.ticket,
            gameref: RelaxModel.gameId,
            mode: RelaxModel.mode,
            partnerid: RelaxModel.partnerid,
            channel: RelaxModel.channel,
            clientid: RelaxModel.clientId,
            currency: RelaxModel.currency
        };
        this.XHR.open('POST', RelaxModel.tokenAPIEndpointURL, true);
        this.XHR.setRequestHeader('Content-Type', 'application/json');
        this.XHR.send(JSON.stringify(requestData));
    }

    sendFunMoneyLogin(data) {
        this.lastRequest = 'funmoneylogin';
        let requestData = {
            mode: RelaxModel.mode,
            partnerid: RelaxModel.partnerid,
            channel: RelaxModel.channel,
            clientid: RelaxModel.clientId,
            g: RelaxModel.gameId,
            immediatePayouts: RelaxModel.immediatePayouts,
            currency: RelaxModel.currency
        };
        this.send('funmoneylogin', requestData);
    }

    sendDemoLogin(data) {
        this.lastRequest = 'demormlogin';
        let requestData = {
            mode: RelaxModel.mode,
            partnerid: RelaxModel.partnerid,
            channel: RelaxModel.channel,
            clientid: RelaxModel.clientId,
            g: RelaxModel.gameId,
            immediatePayouts: RelaxModel.immediatePayouts,
            currency: RelaxModel.currency
        };
        this.send('demormlogin', requestData);

    }

    sendRMLogin(data) {
        this.lastRequest = 'rmlogin';
        let requestData = {
            token: RelaxModel.token,
            userid: RelaxModel.userid,
            mode: RelaxModel.mode,
            partnerid: RelaxModel.partnerid,
            channel: RelaxModel.channel,
            clientid: RelaxModel.clientId,
            g: RelaxModel.gameId,
            country: RelaxModel.country,
            immediatePayouts: RelaxModel.immediatePayouts
        };
        this.send('rmlogin', requestData);
    }

    sendGameFinished(data) {
        //this.lastRequest = 'gamefinished';
        let requestData = {
            g: RelaxModel.gameId,
            sid: RelaxModel.sid,
            restoreVersion: RelaxModel.restoreVersion += 1
        };
        this.restoreStateXHR.open('POST', `${RelaxModel.gameServerAPIendpointURL}/gamefinished`, true);
        this.restoreStateXHR.setRequestHeader('Content-Type', 'application/json');
        this.restoreStateXHR.send(JSON.stringify(requestData));
        //this.send('gamefinished', requestData);
    }

    sendSkipFreeBets(data) {
        this.lastRequest = 'skipfreebets';
        let requestData = {
            sid: RelaxModel.sid,
            action: 'skip'
        };
        this.send('freespins', requestData);

    }

    sendSetRealityCheckLimits(data) {
        //this.lastRequest = 'setrealitychecklimits';
        let requestData = {
            sid: RelaxModel.sid,
            lossLimit: 0,
            sessionLimitSeconds: RelaxModel.rcInterval,
            sessionElapsedSeconds: RelaxModel.rcElapsed
        };
        this.realityCheckXHR.open('POST', `${RelaxModel.gameServerAPIendpointURL}/setrealitychecklimits`, true);
        this.realityCheckXHR.setRequestHeader('Content-Type', 'application/json');
        this.realityCheckXHR.send(JSON.stringify(requestData));
    }

    sendSpin(data) {
        if (ParseRelax.freeSpins && ParseRelax.freeSpins.length > 0) {
            let freeSpinData = ParseRelax.freeSpins.shift();
            freeSpinData.action = 'freeSpin';
            this.parseSpinData(freeSpinData, true);
            setTimeout(() => {
                this.sendSetRestoreState();
            }, 0);
            return;
        }

        this.lastRequest = 'play';
        let requestData = {
            sid: RelaxModel.sid,
            g: RelaxModel.gameId,
            ga: 'spin',
            ba: data.bet,
            restoreVersion: RelaxModel.restoreVersion += 1
        };

        if (EntryPoint.GameModel.freeBets) {
            const restoreState = JSON.stringify(EntryPoint.GameModel.freeBets);
            requestData = {
                ...requestData,
                restoreState
            };
        }

        this.send('play', requestData);
    }

    sendGetSessionResult(data) {
        this.lastRequest = 'getsessionresult';
        let requestData = {
            sid: RelaxModel.sid
        };
        this.send('getsessionresult', requestData);
    }

    sendGetBalance() {
        let requestData = {
            sid: RelaxModel.sid
        };
        this.getBalanceXHR.open('POST', `${RelaxModel.gameServerAPIendpointURL}/getbalance`, true);
        this.getBalanceXHR.setRequestHeader('Content-Type', 'application/json');
        this.getBalanceXHR.send(JSON.stringify(requestData));
    }

    sendPing() {
        let requestData = {
            sid: RelaxModel.sid
        };
        this.pingXHR.open('POST', `${RelaxModel.gameServerAPIendpointURL}/ping`, true);
        this.pingXHR.setRequestHeader('Content-Type', 'application/json');
        this.pingXHR.send(JSON.stringify(requestData));
    }

    sendSetRestoreState(data) {
        //this.lastRequest = 'setrestorestate';
        let requestData = {
            sid: RelaxModel.sid,
            restoreVersion: RelaxModel.restoreVersion += 1,
            restoreState: {
                freeSpins: EntryPoint.GameModel.freeSpins
            },
            g: RelaxModel.gameId
        };
        this.restoreStateXHR.open('POST', `${RelaxModel.gameServerAPIendpointURL}/setrestorestate`, true);
        this.restoreStateXHR.setRequestHeader('Content-Type', 'application/json');
        this.restoreStateXHR.send(JSON.stringify(requestData));
    }

    sendResetRealityCheck(data) {
        //this.lastRequest = 'resetrealitycheck';
        let requestData = {
            sid: RelaxModel.sid,
            loss: true,
            sessionLength: true
        };
        this.realityCheckXHR.open('POST', `${RelaxModel.gameServerAPIendpointURL}/resetrealitycheck`, true);
        this.realityCheckXHR.setRequestHeader('Content-Type', 'application/json');
        this.realityCheckXHR.send(JSON.stringify(requestData));
    }

    send(command, data) {
        this.XHR.open('POST', `${RelaxModel.gameServerAPIendpointURL}/${command}`, true);
        this.XHR.setRequestHeader('Content-Type', 'application/json');
        this.XHR.send(JSON.stringify(data));
    }

    onError(event) {
        let data = {
            errorCode: 'connection'
        };
        ErrorsManager.getError(data);
    }

    onHasData(event) {
        let data = JSON.parse(event.target.response);
        if (data.errorCode) {
            ErrorsManager.getError(data);
            return;
        }
        //console.log(event.data);
        switch (this.lastRequest) {
            case 'demormlogin':
                this.onDemoLoginLoad(data);
                break;
            case 'funmoneylogin':
                this.onFunMoneyLoad(data);
                break;
            case 'gettoken':
                this.onGetTokenLoad(data);
                break;
            case 'rmlogin':
                this.onRMLoginLoad(data);
                break;
            case 'skipfreebets':
                this.onSkipFreeBetsLoad(data);
                break;
            case 'setrealitychecklimits':

                break;
            case 'setrestorestate':

                break;
            case 'resetrealitycheck':

                break;
            case 'getbalance':

                break;
            case 'play':
                this.onPlayLoad(data);
                break;
            case 'gamefinished':

                break;
            case 'getsessionresult':
                this.onGetSessionResultLoad(data);
                break;
        }
        //this.lastRequest = '';
    }

    onRealityCheckHasData(event) {
        let data = JSON.parse(event.target.response);
        if (data.errorCode) {
            ErrorsManager.getError(data);
            return;
        }
    }

    onRestoreStateHasData(event) {
        let data = JSON.parse(event.target.response);
        if (data.errorCode) {
            ErrorsManager.getError(data);
            return;
        }
    }

    onGetBalanceHasData(event) {
        let data = JSON.parse(event.target.response);
        if (data.errorCode) {
            ErrorsManager.getError(data);
            return;
        }
        GlobalDispatcher.dispatch('dataProvider:hasResponse', ParseRelax.parseGetBalance(data));
    }

    onPingHasData(event) {
        let data = JSON.parse(event.target.response);
        if (data.errorCode) {
            ErrorsManager.getError(data);
            return;
        }
        GlobalDispatcher.dispatch('dataProvider:hasResponse', ParseRelax.parsePing(data));
    }

    onDemoLoginLoad(data) {
        let parsedData = ParseRelax.parseDemoLoginResponse(data);
        //console.log(parsedData);
        GlobalDispatcher.dispatch('dataProvider:hasResponse', parsedData);

        this.sendSetRealityCheckLimits();
    }

    onFunMoneyLoad(data) {
        let parsedData = ParseRelax.parseDemoLoginResponse(data);
        //console.log(parsedData);
        GlobalDispatcher.dispatch('dataProvider:hasResponse', parsedData);

        this.sendSetRealityCheckLimits();
    }

    onGetTokenLoad(data) {
        ParseRelax.parsGetToken(data);
        this.sendRMLogin();
    }

    onRMLoginLoad(data) {
        let parsedData = ParseRelax.parsRMLogin(data);
        //console.log(parsedData);
        GlobalDispatcher.dispatch('dataProvider:hasResponse', parsedData);
        /*if (parsedData.freeBets) {
            this.sendSkipFreeBets();
        }*/
        this.sendSetRealityCheckLimits();
    }

    onSkipFreeBetsLoad(data) {
        /*let parsedData = ParseRelax.parseDemoLoginResponse(data);
        console.log(parsedData);
        GlobalDispatcher.dispatch('dataProvider:hasResponse', parsedData);*/
    }

    onPlayLoad(data) {
        this.parseSpinData(data);
    }

    onGetSessionResultLoad(data) {
        //console.log('!!!', data);
        RelaxModel.realityCheck.winSum = data.winamount;
        RelaxModel.realityCheck.betSum = data.betamount;
    }

    parseSpinData(dataSrc, freeSpins = false) {
        let data = ParseRelax.parseSpinResponse(dataSrc, freeSpins);
        //console.log(data);

        if (RelaxModel.realityCheck && RelaxModel.realityCheck.status === 'error' && RelaxModel.rcShowResult === 'true') {
            this.sendGetSessionResult();
        }
        GlobalDispatcher.dispatch('dataProvider:hasResponse', data);
    }
}
